<div *ngIf="canViewExcel==null || canViewExcel=='' || canViewExcel=='N'"   style="display:flex; justify-content:center;margin-top:20px;">
  <a style="color: #f9f3f5; background-color: #117090; font-size: 18px; font-weight: bold;" mat-raised-button href="mailto:R3APRequest@age.ohio.gov">
    <mat-icon style="color: #f2f2f2;">contact_support</mat-icon>
    Any questions? Click here
  </a>
</div>
<div *ngIf="canViewExcel=='Y'"    style="display:flex; justify-content:center;margin-top:20px;">
    <a style="color: #f9f3f5; background-color: #117090; font-size: 18px; font-weight: bold;" mat-raised-button href="mailto:AgeExcel@age.ohio.gov">
    <mat-icon style="color: #f2f2f2;">contact_support</mat-icon>
    Any questions? Click here
  </a>
</div>
<nav class="navbar  navbar-expand-sm navbar-dark bg-dark mt-4 app-footer">
  <div class="container">    
    <div class="collapse navbar-collapse" id="navbarCollapse">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item active">
          <span class="nav-link">
            &copy; Copyright {{year}} by Ohio Department of Aging - Care Center Portal version : {{version}}. All Rights Reserved.
          </span>
        </li>
      </ul>
    </div>
  </div>
</nav>
